import { Link } from "react-router-dom";
import { handleBlurOnClick } from "./navbarUtils";
import { getAppName } from "../../../../auxiliar/auxFunctions";

const BrandLogo = ({ to, size = "desktop", className = "" }) => {
    const isDesktop = size === "desktop";
    const logoSize = isDesktop ? "w-7 h-7" : "w-6 h-6";
    const baseClassName = `btn btn-ghost text-xl ${
        isDesktop ? "hidden xl:flex" : "flex xl:hidden"
    } items-center gap-3 hover:bg-gradient-to-r hover:from-primary/10 hover:to-primary/5 active:bg-gradient-to-r active:from-primary/15 active:to-primary/8 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-primary/30 focus:ring-offset-2 focus:ring-offset-base-100 active:scale-95`;

    return (
        <Link className={`${baseClassName} ${className}`} to={to} onClick={handleBlurOnClick}>
            <div className="relative">
                <img
                    src={require("../../../../media/icon/icon_64.png")}
                    alt="MiFisio Logo"
                    className={`${logoSize} transition-transform duration-300 hover:scale-110 active:scale-105`}
                />
                <div className="absolute inset-0 bg-primary/20 rounded-full blur-md opacity-0 hover:opacity-100 transition-opacity duration-300"></div>
            </div>
            <span className="font-bold text-primary bg-gradient-to-r from-primary to-primary/80 bg-clip-text">
                {getAppName()}
            </span>
        </Link>
    );
};

export default BrandLogo;
